"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubContent = exports.MainContent = exports.ImageContainer = exports.DropzoneContainer = exports.ButtonWrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var getColor = function getColor(props) {
  if (props.isDragAccept) {
    return props.theme.banner.imageBoxDragAccept.borderColor;
  }

  if (props.isDragReject) {
    return props.theme.banner.imageBoxDragReject.borderColor;
  }

  if (props.isFocused) {
    return props.theme.banner.imageBoxFocused.borderColor;
  }

  return props.theme.banner.imageBox.borderColor;
};

var ImageContainer = _styledComponents["default"].div.withConfig({
  displayName: "GenericFileUploadDragNDropstyles__ImageContainer",
  componentId: "sc-1vwunyd-0"
})(["flex:1;display:flex;flex-direction:column;align-items:center;padding:10px;border-width:2px;border-radius:2px;border-color:", ";border-style:dashed;background-color:", ";outline:none;transition:border 0.24s ease-in-out;cursor:pointer;img{height:118px;width:118px;}"], function (props) {
  return getColor(props);
}, function (props) {
  return props.theme.banner.imageBox.backgroundColor;
});

exports.ImageContainer = ImageContainer;

var MainContent = _styledComponents["default"].h1.withConfig({
  displayName: "GenericFileUploadDragNDropstyles__MainContent",
  componentId: "sc-1vwunyd-1"
})(["margin:0;font-family:'Open Sans';font-style:normal;font-size:16px;font-weight:700;line-height:22px;letter-spacing:0px;text-align:center;padding-top:5px;em{color:black;font-style:normal;}"]);

exports.MainContent = MainContent;

var SubContent = _styledComponents["default"].h2.withConfig({
  displayName: "GenericFileUploadDragNDropstyles__SubContent",
  componentId: "sc-1vwunyd-2"
})(["font-family:'Open Sans';font-style:normal;font-size:16px;font-weight:600;line-height:22px;letter-spacing:0px;text-align:center;opacity:20%;margin-bottom:5px;"]);

exports.SubContent = SubContent;

var ButtonWrapper = _styledComponents["default"].div.withConfig({
  displayName: "GenericFileUploadDragNDropstyles__ButtonWrapper",
  componentId: "sc-1vwunyd-3"
})(["margin:1rem 0;display:flex;flex-direction:column;justify-content:center;"]);

exports.ButtonWrapper = ButtonWrapper;

var DropzoneContainer = _styledComponents["default"].div.withConfig({
  displayName: "GenericFileUploadDragNDropstyles__DropzoneContainer",
  componentId: "sc-1vwunyd-4"
})(["width:100%;"]);

exports.DropzoneContainer = DropzoneContainer;